import { type ButtonProps } from '@liquidweb-dev/undercurrent/Button/Button';
import combineSx from '@liquidweb-dev/undercurrent/utility/combineSx';

import { useForm } from 'components/LWForm';
import HookedSubmit from 'components/standard/Form/HookedSubmit';

const DestroyButton = ({ children, sx, ...rest }: ButtonProps) => {
	const form = useForm();
	const disabled = form.values.verification_text !== 'CONTINUE';

	return (
		<HookedSubmit
			size="large"
			variant="secondary"
			color="danger"
			sx={combineSx({ maxWidth: '248px', width: '100%' }, sx)}
			disabled={disabled}
			{...rest}
		>
			{children || 'Confirm cancellation'}
		</HookedSubmit>
	);
};

export default DestroyButton;
